import { ArrowLeft, Construction, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { PageView } from "@/types/maturity";

type AssistedViewProps = {
  onNavigate: (view: PageView) => void;
};

function AssistedView({ onNavigate }: AssistedViewProps) {
  return (
    <div className="max-w-[1120px] mx-auto flex flex-col items-center justify-center min-h-[60vh] text-center space-y-6">
      <div className="w-16 h-16 bg-amber-100 rounded-2xl flex items-center justify-center">
        <Construction className="w-8 h-8 text-amber-600" />
      </div>

      <div className="space-y-2">
        <h1 className="text-2xl font-bold text-slate-800">
          Evaluarea asistată va fi disponibilă în curând
        </h1>
        <p className="text-slate-500 max-w-lg mx-auto">
          Un specialist NIS2PASS te va ghida printr-o sesiune interactivă de
          maximum 2 ore pentru a completa evaluarea de maturitate.
        </p>
      </div>

      <div className="flex flex-col sm:flex-row gap-3">
        <Button variant="outline" onClick={() => onNavigate("summary")}>
          <ArrowLeft className="w-4 h-4" />
          Înapoi
        </Button>
        <Button asChild>
          <a href="mailto:contact@nis2pass.ro?subject=Evaluare%20asistată%20maturitate%20CyFun">
            <Mail className="w-4 h-4" />
            Contactează-ne pentru a programa
          </a>
        </Button>
      </div>
    </div>
  );
}

export default AssistedView;
